import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";

const IndentModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Function to fetch indent records
  const fetchData = async (search = "") => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/store_req_modal", {
        params: { branchcode: branch, itemName: search, itemCode: search },
      });
      setSearchResults(response.data);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
    setLoading(false);
  };

  // Fetch all records when the modal opens or branch changes
  useEffect(() => {
    if (showModal) {
      fetchData();
    }
  }, [showModal, branch]);

  // Search functionality with debounce
  useEffect(() => {
    if (!showModal) return; // Prevent unnecessary API calls when modal is closed

    const delaySearch = setTimeout(() => {
      fetchData(searchTerm.trim());
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTerm]);

  const handleSelectItem = (item) => {
    onSelectItem(item);
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Add Store Requisition Item</h3>
        <div className="search-containerr">
          <label className="search-labell">Search Item:</label>
          <input
            type="text"
            className="search-inputt"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Type to search..."
          />
        </div>

        {loading && <p className="loading-text">Loading...</p>}

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>Indent No</th>
                <th>Date</th>
                <th>Dept</th>
                <th>Supervisor</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length > 0 ? (
                searchResults.map((item) => (
                  <tr key={item.indentHeader_number}>
                    <td>{item.indentHeader_number}</td>
                    <td>
  {new Date(item.indentHeader_date).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })}
</td>

                    <td>{item.DepartmentMaster_name}</td>
                    <td>{item.userId}</td>
                    <td>
                      <button className="select-btn" onClick={() => handleSelectItem(item)}>Select</button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default IndentModal;
